import { useQuery } from "@apollo/client";

import { gql } from "~/__generated__";

const PROJECT_GET_ALL_ROLES = gql(`
    query ProjectGetAllRoles {
        projectGetAllRoles {
            id
            name
        }
    }
`);

export default function useProjectUserGetAllRoles() {
    const { data, loading, error } = useQuery(PROJECT_GET_ALL_ROLES, {
        errorPolicy: "all",
    });

    return {
        allRoles: data?.projectGetAllRoles ?? [],
        loading,
        error,
    };
}
